import CenterContainer from './CenterContainer'
import { useRouteError } from 'react-router'
import { useEffect } from 'react'

export function ErrorPage() {
  const error = useRouteError()
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <CenterContainer className="p-10">
      <div className="flex flex-col items-center">
        <img
          src="/J14/Asset/Star.svg"
          width={128}
          height={128}
          alt=""
          aria-hidden
        />
        <h1 className="mt-6 text-2xl md:text-3xl font-bold text-yellow-300 font-thai-looped drop-shadow-md text-center">
          เกิดข้อผิดพลาด โปรดลองใหม่อีกครั้ง
        </h1>
      </div>
    </CenterContainer>
  )
}
